export default {
    //RecordsList
    your_records: 'Tus grabaciones',
    loading_records: 'Cargando grabaciones...',
    project_name: 'Nombre del Curso',
    class_name: 'Nombre de la Clase',
    participants: 'Participantes',
    total_size: 'Tamaño total',

}